// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ra-z","fullWidth":"Sa-z","heading":"Ta-z","fullBleed":"Ua-z","hidden":"Va-z","screenReadersOnly":"Wa-z"};